import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useContext } from 'react'
import { SessionContext } from 'contexts/session'

type Params = {
  stationCode: string
  blockIndex: string
}

function useHvacListQuery() {
  const { stationCode, blockIndex } = useParams<Params>()
  const { session } = useContext<any>(SessionContext)

  return useQuery(
    ['hvacList', stationCode, blockIndex],
    async () => {
      const apiUrl = session.server
      const axiosOptions = {
        headers: {
          Accept: 'application/json',
          papitoken: session.token,
        },
      }
      const response = await axios.get(
        `${apiUrl}station/${stationCode}/block/${blockIndex}/hvacs`,
        axiosOptions,
      )
      return response.data
    },
    { refetchInterval: 5000 },
  )
}

export default useHvacListQuery
